import React, { Fragment } from "react"; 
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts/LayoutOne";  
import BlogPageContent from "../templates/Blog/index";


const blogPage = () => {
	return (
	  <Fragment>
		<MetaTags>
		  <title>SAPIT | Solutions</title>
		  <meta
			name="description"
			content="SAPIT"
		  />
		</MetaTags>
		<LayoutOne>
			
			{/* <PageHeader
				bgImg={require('../assets/images/page_bg.jpg')}
				title="Solutions" 
			/> */}

			<BlogPageContent />
			
		</LayoutOne>
	  </Fragment>
	);
  };
  
  export default blogPage;



